<div class="toolbar-break"></div>
@for (policy of policies$ | async; track policy) {
  @if (policy.policyType === privacy) {
    <div class="container my-3">
      <div [innerHTML]="policy.html">
      </div>
    </div>
  }
}